module.exports = __webpack_public_path__ + "img/icon-edit-red.2b76507b.svg";